// Externals
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie-player";

// Accordion
import {
	Accordion,
	AccordionItem as Item,
	AccordionItemHeading as ItemHeading,
	AccordionItemButton as ItemButton,
	AccordionItemPanel as ItemPanel,
} from "react-accessible-accordion";

// Components
import Header from "../components/Header";
import { Button } from "../components/Fields";
import Above18 from "../components/Above18";

// Custom Hooks
import { useDesktop } from "../utils/useDesktop";

// Animation Data
import animationData1 from "../static/lottie/Home_Dog_A_cropped.json";
import animationData2 from "../static/lottie/Home_Dog_B_cropped.json";

// Styles
import "./Welcome.scss";
import "./Instructions.scss";

/*::
type Props = {
}
*/
const Welcome = (props /*: Props */) /*: React.Component */ => {
	// Custom Hooks
	const isDesktop = useDesktop();

	// States
	const [showAbove18Window, setAbove18Window] = useState(false);

	// useEffects
	useEffect(() => {}, [showAbove18Window]);

	const above18Handler = () => {
		setAbove18Window((state) => !state);
	};

	return (
		<>
			<Header />
			<div className="welcome">
				<div
					className="welcome-animation"
					data-cy={`welcome-animation`}
				>
					<Lottie
						width="350px"
						height="350px"
						className="lottie-container basic"
						animationData={animationData1}
						play={true}
						loop={true}
					/>
				</div>
				<div className="welcome-content">
					{isDesktop ? (
						<h1>
							<span>WELCOME</span>
							<br />
							TO RSPCA
							<br />
							COMPETIBLE
						</h1>
					) : (
						<h1>
							<span>WELCOME</span>
							<br />
							TO RSPCA COMPETIBLE
						</h1>
					)}
					<p>
						When it comes to choosing the right dog, it's their
						personality, not their looks, that really matters.
						That's what makes you and your dog not just compatible,
						but Competible.
					</p>
					<Button
						label="Start"
						onClick={above18Handler}
						data-cy="welcome-button"
					/>
				</div>
				<div className="arrow"></div>
			</div>
			<div className="instructions">
				<div className="instructions-content1">
					<h1>
						Find the dog
						<br />
						who's just like you.
					</h1>
					<div className="content-flex">
						<div className="left">
							<p>
								RSPCA Competible™ uses data science and
								behavioural analytics to match you perfectly
								with a lifelong friend. So you can be sure
								you've found the dog who's right for you.
							</p>
						</div>
						<div className="right" data-cy="instruction-animation">
							<Lottie
								className="lottie-container basic"
								animationData={animationData2}
								play={true}
								loop={true}
							/>
						</div>
					</div>
					<Accordion allowZeroExpanded>
						<Item>
							<ItemHeading>
								<ItemButton>How does it work?</ItemButton>
							</ItemHeading>
							<ItemPanel>
								<p>
									Just answer a few simple questions and we
									will send you your Competible matches. It
									only takes five minutes.
								</p>
							</ItemPanel>
						</Item>
						<Item>
							<ItemHeading>
								<ItemButton>
									Will I always get a match?
								</ItemButton>
							</ItemHeading>
							<ItemPanel>
								<p>
									We may not find your perfect pup today, but
									we'll be sure to let you know when future
									matches come up.
								</p>
								<p>
									Even if we do find a suitable dog for you,
									we can't guarantee you'll be able to take
									that exact pet home. Standard RSPCA NSW
									adoption procedures still apply so pop down
									to one of our shelters for a meet and greet,
									and we'll go from there.
								</p>
							</ItemPanel>
						</Item>
						<Item>
							<ItemHeading>
								<ItemButton>
									What if I don’t want to adopt yet?
								</ItemButton>
							</ItemHeading>
							<ItemPanel>
								<p>
									Whether you're looking to adopt today or in
									the future, it can still be great finding
									out which dog is right for you.
								</p>
							</ItemPanel>
						</Item>
					</Accordion>
				</div>
				<Button
					label="Start"
					onClick={above18Handler}
					data-cy="start"
				/>

				{isDesktop && <div className="floor-container" />}
			</div>

			<Above18
				showAbove18Window={showAbove18Window}
				onToggle={above18Handler}
			/>
		</>
	);
};

// Exports
export default Welcome;
